import { gql, useQuery } from "@apollo/client";
import { FaPaw } from "react-icons/fa";
import { SimpleStatCard } from "./StatsUI";
import PawLoader from "../../components/PawLoader";

const GLOBAL_STATS_QUERY = gql`
  query GlobalStats {
    globalStats {
      totalUsers
      totalVideos
      activeUsersLastWeek
      ageGroupTotalViews
    }
  }
`;

const GlobalStats = () => {
  const { data, loading, error } = useQuery(GLOBAL_STATS_QUERY, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true,
  });

  if (loading)
    return (
      <div className="h-[300px] my-5">
        <PawLoader size={100} />
      </div>
    );

  if (error)
    return (
      <div className="h-[300px] my-5">
        <p>Error loading personal stats</p>
      </div>
    );
  const { totalVideos, ageGroupTotalViews } = data.globalStats;

  // completion % for this age‐group
  const completionRate =
    totalVideos > 0 ? Math.round((ageGroupTotalViews / totalVideos) * 100) : 0;

  return (
    <>
      <h2 className="text-2xl font-semibold mt-8">Community wide stats</h2>
      <div className="grid grid-cols-2 gap-4 my-4">
        <SimpleStatCard
          title="Users"
          value={ageGroupTotalViews}
          subtitle="Avg number of active annotators last week"
        />

        <div className="p-4 bg-[#232222] text-[#FFFFFF] rounded-lg flex items-center space-x-2">
          <FaPaw className="text-yellow-400 text-4xl" />
          <div>
            <p className="text-4xl font-bold">{completionRate}%</p>
            <p className="text-sm">Your age-group annotated so far</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default GlobalStats;
